import {
  FETCHING_ROLODEX_CONTACTS_REQUEST,
  FETCHING_ROLODEX_CONTACTS_SUCCEDDED,
  FETCHING_ROLODEX_CONTACTS_FAILED,
  INVALIDATE_ROLODEX_CONTACTS,
  VIEW_CONTACT_REQUEST,
  INVALIDATE_CONTACT,
  FETCHING_CONTACT_SHARES_ANALYTICS_REQUEST,
  FETCHING_CONTACT_SHARES_ANALYTICS_SUCCEDDED,
  FETCHING_CONTACT_SHARES_ANALYTICS_FAILED,
  FETCHING_CONTACT_SHARE_REQUEST,
  FETCHING_CONTACT_SHARE_SUCCEDDED,
  FETCHING_CONTACT_SHARE_FAILED,
  FETCHING_CONTACT_SHARE_SECTION_REQUEST,
  FETCHING_CONTACT_SHARE_SECTION_SUCCEDDED,
  FETCHING_CONTACT_SHARE_SECTION_FAILED,
  FETCHING_CONTACT_ASSET_ANALYTICS_REQUEST,
  FETCHING_CONTACT_ASSET_ANALYTICS_SUCCEDDED,
  FETCHING_CONTACT_ASSET_ANALYTICS_FAILED,
  CREATING_CONTACT_REQUEST,
  CREATING_CONTACT_SUCCEDDED,
  CREATING_CONTACT_FAILED,
  UPDATING_CONTACT_REQUEST,
  UPDATING_CONTACT_SUCCEDDED,
  UPDATING_CONTACT_FAILED,
  DELETING_CONTACT_REQUEST,
  DELETING_CONTACT_FAILED,
  FETCHING_CONTACT_REQUEST,
  FETCHING_CONTACT_SUCCEDDED,
  FETCHING_CONTACT_FAILED,
  UNSUBSCRIBING_CONTACT_REQUEST,
  UNSUBSCRIBING_CONTACT_SUCCEDDED,
  UNSUBSCRIBING_CONTACT_FAILED,
  RESUBSCRIBING_CONTACT_REQUEST,
  RESUBSCRIBING_CONTACT_SUCCEDDED,
  RESUBSCRIBING_CONTACT_FAILED,
  FETCHING_ASSET_PREVIEW,
  FETCHING_ASSET_PREVIEW_SUCCEDDED,
  FETCHING_ASSET_PREVIEW_FAILED,
  FETCHING_INTEGRATION_CONTACTS,
  FETCHING_INTEGRATION_CONTACTS_SUCCEEDED,
  FETCHING_INTEGRATION_CONTACTS_FAILED,
  INVALIDATE_INTEGRATION_CONTACTS,

} from "../actions/actionTypes.jsx";

import _ from "lodash";

var initialContactState = {
  id: 0,
  creating: false,
  updating: false,
  deleting: false,
  loading: false,
  error: null,
  item: null,
  shares: {
    loading: false,
    items: [],
    pagination: {
      current: -1,
      totalPages: 1,
    },
  },
};

const initialState = {
  loading: false,
  invalidated: true,
  items: [],
  pagination: {
    current: -1,
    totalPages: 1,
  },
  contact: {
    ...initialContactState,
  },
  subscription: {
    updating: false,
    subscribed: true,
    error: null,
  },
  integrations: {
    id: null,
    query: null,
    searching: false,
    currentPage: -1,
    totalPages: 0,
    totalRecordsCount: 0,
    recordsPerPage: 12,
    items: [],
    fetched: false,
  },

  assetAnalytics: {
    analytics: {},
    assetPreview: {},
  }
};

function rolodexReducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING_ROLODEX_CONTACTS_REQUEST:
      return Object.assign({}, state, {
        ...state,
        loading: true,
        invalidated: true,
      });

    case FETCHING_ROLODEX_CONTACTS_SUCCEDDED:
      var records = action.payload.records;
      var items = [];

      if (action.payload.currentPage != 0) {
        items = [...state.items, ...action.payload.records];
      } else {
        items = action.payload.records;
      }

      items = _.uniqBy(items, "id");

      items = items
        .filter((field) => {
          return field != null && field.id != null;
        })
        .sort((a, b) => {
          if (a.id && b.id) {
            var n1 = a.firstName || "";
            var n2 = b.firstName || "";
            return n1.localeCompare(n2);
          }

          return 1;
        });

      items = _.sortBy(items, obj => _.get(obj, "firstName").toLowerCase());

      return Object.assign({}, state, {
        ...state,
        loading: false,
        invalidated: false,
        items: items,
        pagination: {
          ...state.pagination,
          current: action.payload.currentPage,
          totalPages: action.payload.totalPages,
        },
      });

    case FETCHING_ROLODEX_CONTACTS_FAILED:
      return Object.assign({}, state, {
        ...state,
        loading: false,
        invalidated: false,
        error: action.payload.error,
      });

    case INVALIDATE_ROLODEX_CONTACTS:
      return initialState;

    case VIEW_CONTACT_REQUEST:
      const id = action.payload;
      let contact = null;
      if (state.items) {
        contact = state.items.find(function (contact) {
          return contact.id == id;
        });
      }

      return Object.assign({}, state, {
        ...state,
        contact: {
          ...initialContactState,
          id: id,
          item: contact,
          fetchingActivities: false,
          fetchingAnalytics: false,
          assetAnalytics: null,
        },
      });

    case INVALIDATE_CONTACT:
      return Object.assign({}, state, {
        ...state,
        contact: {
          ...initialContactState,
        },
      });

    case FETCHING_CONTACT_REQUEST:

      {
        const id = action.payload.id;

        return Object.assign({}, state, {
          ...state,
          contact: {
            ...initialContactState,
            id: id,
            loading: true,
          },
        });
      }

    case FETCHING_CONTACT_SUCCEDDED:
      {
        const id = action.payload.id;
        const contact = action.payload.contact;

        return Object.assign({}, state, {
          ...state,
          contact: {
            ...state.contact,
            id: id,
            loading: false,
            item: contact,
          },
        });
      }

    case FETCHING_CONTACT_FAILED:
      {
        const id = action.payload.id;
        var error = action.payload.error;

        return Object.assign({}, state, {
          ...state,
          contact: {
            ...state.contact,
            id: id,
            loading: false,
            error: error,
          },
        });
      }
    case FETCHING_CONTACT_SHARES_ANALYTICS_REQUEST:
      {
        const id = action.payload.id;

        if (state.contact.id != id) {
          return state;
        }

        return Object.assign({}, state, {
          contact: {
            ...state.contact,
            shares: {
              ...state.contact.shares,
              loading: true,
            },
          },
        });
      }

    case FETCHING_CONTACT_SHARES_ANALYTICS_SUCCEDDED:
      {

        const id = action.payload.id;
        var result = action.payload.shares;

        if (state.contact.id != id) {
          return state;
        }

        var records = result.records;
        if (records) {
          records = records.map((share) => {
            if (share.assets) {
              share.assets = share.assets.map((asset) => {
                return Object.assign({}, asset, {
                  ...asset,
                  analytics: {
                    fetch: true,
                    loading: false,
                    item: null,
                  },
                  preview: {
                    loading: false,
                    item: null,
                    fetch: true,
                  },
                });
              });
            }

            return Object.assign({}, share, {
              ...share,
              fetchedChildren: false,
              fetching: false,
            });
          });
        }

        if (action.payload.currentPage != 0) {
          items = [...state.contact.shares.items, ...records];
        } else {
          items = records;
        }

        items = items.reduce((x, y) => {
          var index = x.findIndex((e) => {
            return e.id == y.id;
          });

          if (index < 0) {
            return [...x, y];
          } else {
            x[index] = y;
            return x;
          }
        }, []);

        return Object.assign({}, state, {
          contact: {
            ...state.contact,
            shares: {
              loading: false,
              items: items,
              pagination: {
                ...state.contact.shares.pagination,
                current: result.currentPage,
                totalPages: result.totalPages,
              },
            },
          },
        });
      }
    case FETCHING_CONTACT_SHARES_ANALYTICS_FAILED:
      {
        const id = action.payload.id;
        var error = action.payload.error;

        if (state.contact.id != id) {
          return state;
        }

        return Object.assign({}, state, {
          contact: {
            ...state.contact,
            shares: {
              ...shares,
              loading: false,
              items: [],
              error: error,
            },
          },
        });
      }

    case FETCHING_CONTACT_SHARE_REQUEST:
      {
        const contact = action.payload.contact;
        var share = action.payload.share;

        if (contact != state.contact.id) {
          return state;
        }

        var shares = state.contact.shares.items.map((item) => {
          if (item.id === share) {
            return Object.assign({}, item, {
              ...item,
              fetchedChildren: false,
              fetching: true,
            });
          }

          return item;
        });

        return Object.assign({}, state, {
          contact: {
            ...state.contact,
            shares: {
              ...state.contact.shares,
              items: shares,
            },
          },
        });
      }

    case FETCHING_CONTACT_SHARE_SUCCEDDED: {


      const contact = action.payload.contact;
      var share = action.payload.share;

      if (contact != state.contact.id) {
        return state;
      }

      var shares = state.contact.shares.items.map((item) => {
        if (item.id === share.id) {
          if (share.assets) {
            share.assets = share.assets.map((asset) => {
              return Object.assign({}, asset, {
                ...asset,
                analytics: {
                  fetch: true,
                  loading: false,
                  item: null,
                },
                preview: {
                  loading: false,
                  item: null,
                  fetch: true,
                },
              });
            });
          }

          return Object.assign({}, item, {
            ...item,
            ...share,
            fetchedChildren: true,
            fetching: false,
          });
        }

        return item;
      });

      return Object.assign({}, state, {
        contact: {
          ...state.contact,
          shares: {
            ...state.contact.shares,
            items: shares,
          },
        },
      });
    }

    case FETCHING_CONTACT_SHARE_FAILED:
      {
        const contact = action.payload.contact;
        var share = action.payload.share;
        var error = action.payload.error;

        if (contact != state.contact.id) {
          return state;
        }

        var shares = state.contact.shares.items.map((item) => {
          if (item.id === share) {
            return Object.assign({}, item, {
              ...item,
              ...share,
              fetchedChildren: false,
              fetching: false,
              error: error,
            });
          }

          return item;
        });

        return Object.assign({}, state, {
          contact: {
            ...state.contact,
            shares: {
              ...state.contact.shares,
              items: shares,
            },
          },
        });
      }

    case FETCHING_CONTACT_SHARE_SECTION_REQUEST: {
      const { share: shareId, section: sectionId } = action.payload;
    
      // Create a new shares array to avoid mutating state
      const shares = state.contact.shares.items.map(share => {
        if (share.id === shareId) {
          // Create a new sections array
          const sections = (share.sections || []).map(section => {
            if (section.id === sectionId) {
              // Return a new section object with loading set to true
              return {
                ...section,
                loading: true,
              };
            }
            return section; // Return existing section if no changes
          });
    
          // Return a new share object with updated sections
          return {
            ...share,
            sections,
          };
        }
        return share; // Return existing share if no changes
      });
    
      // Return a new state object
      return {
        ...state,
        contact: {
          ...state.contact,
          shares: {
            ...state.contact.shares,
            loading: false,
            items: shares,
          },
        },
      };
    }
    
    case FETCHING_CONTACT_SHARE_SECTION_SUCCEDDED: {
      const { share: shareId, section } = action.payload;
      const sectionId = section.id;
    
      // Create a new shares array to avoid mutating state
      const shares = state.contact.shares.items.map(share => {
        if (share.id === shareId) {
          // Create a new sections array
          const sections = (share.sections || []).map(sec => {
            if (sec.id === sectionId) {
              // Return a new section object with updated assets
              return {
                ...sec,
                assets: section.assets.map(asset => ({
                  ...asset,
                  analytics: {
                    fetch: true,
                    loading: false,
                    item: null,
                  },
                  preview: {
                    loading: false,
                    item: null,
                    fetch: true,
                  },
                })),
                loading: false,
                fetched: true,
              };
            }
            return sec; // Return existing section if no changes
          });
    
          // Return a new share object with updated sections
          return {
            ...share,
            sections,
          };
        }
        return share; // Return existing share if no changes
      });
    
      // Return a new state object
      return {
        ...state,
        contact: {
          ...state.contact,
          shares: {
            ...state.contact.shares,
            loading: false,
            items: shares,
          },
        },
      };
    }
    
    case FETCHING_CONTACT_SHARE_SECTION_FAILED: {
      const { share: shareId, section: sectionId } = action.payload;
    
      // Create a new shares array to avoid mutating state
      const shares = state.contact.shares.items.map(share => {
        if (share.id === shareId) {
          // Create a new sections array
          const sections = (share.sections || []).map(section => {
            if (section.id === sectionId) {
              // Return a new section object with loading set to true
              return {
                ...section,
                loading: false,
                fetched: false,
              };
            }
            return section; // Return existing section if no changes
          });
    
          // Return a new share object with updated sections
          return {
            ...share,
            sections,
          };
        }
        return share; // Return existing share if no changes
      });
    
      // Return a new state object
      return {
        ...state,
        contact: {
          ...state.contact,
          shares: {
            ...state.contact.shares,
            loading: false,
            items: shares,
          },
        },
      };
    }
   

   
    case FETCHING_CONTACT_ASSET_ANALYTICS_REQUEST: {
      const { contact: contactID, share: shareID, section: sectionID, asset: assetID } = action.payload;
    
      // Create a new items array to avoid mutating state
      const items = state.contact.shares.items.map(share => {
        if (share.id === shareID) {
          // Create a new assets array for the share
          const assets = share.assets.map(asset => {
            if (asset.id === assetID) {
              return {
                ...asset,
                analytics: {
                  ...asset.analytics,
                  fetch: false,
                  loading: true,
                },
                preview: {
                  loading: false,
                  item: null,
                  fetch: true,
                },
              };
            }
            return asset; // Return existing asset if no changes
          });
    
          // Create a new sections array
          const sections = (share.sections || []).map(section => {
            if (section.id === sectionID) {
              // Create a new assets array for the section
              const sectionAssets = section.assets.map(asset => {
                if (asset.id === assetID) {
                  return {
                    ...asset,
                    analytics: {
                      ...asset.analytics,
                      fetch: false,
                      loading: true,
                    },
                    preview: {
                      loading: false,
                      item: null,
                      fetch: true,
                    },
                  };
                }
                return asset; // Return existing asset if no changes
              });
    
              // Return a new section object with updated assets
              return {
                ...section,
                assets: sectionAssets,
              };
            }
            return section; // Return existing section if no changes
          });
    
          // Return a new share object with updated assets and sections
          return {
            ...share,
            assets,
            sections,
          };
        }
        return share; // Return existing share if no changes
      });
    
      // Return a new state object
      return {
        ...state,
        contact: {
          ...state.contact,
          shares: {
            ...state.contact.shares,
            items,
          },
        },
      };
    }
    case FETCHING_CONTACT_ASSET_ANALYTICS_SUCCEDDED: {
      const { share: shareID, asset: assetID, section: sectionID, analytics } = action.payload;
    
      // Create a new items array to avoid mutating state
      const items = state.contact.shares.items.map(share => {
        if (share.id === shareID) {
          // Create a new assets array for the share
          const assets = share.assets.map(asset => {
            if (asset.id === assetID) {
              return {
                ...asset,
                analytics: {
                  ...asset.analytics,
                  fetch: false,
                  loading: false,
                  item: analytics,
                },
                preview: {
                  loading: false,
                  item: null,
                  fetch: true,
                },
              };
            }
            return asset; // Return existing asset if no changes
          });
    
          // Create a new sections array
          const sections = (share.sections || []).map(section => {
            if (section.id === sectionID) {
              // Create a new assets array for the section
              const sectionAssets = section.assets.map(asset => {
                if (asset.id === assetID) {
                  return {
                    ...asset,
                    analytics: {
                      ...asset.analytics,
                      fetch: false,
                      loading: false,
                      item: analytics,
                    },
                    preview: {
                      loading: false,
                      item: null,
                      fetch: true,
                    },
                  };
                }
                return asset; // Return existing asset if no changes
              });
    
              // Return a new section object with updated assets
              return {
                ...section,
                assets: sectionAssets,
              };
            }
            return section; // Return existing section if no changes
          });
    
          // Return a new share object with updated assets and sections
          return {
            ...share,
            assets,
            sections,
          };
        }
        return share; // Return existing share if no changes
      });
    
      // Return a new state object
      return {
        ...state,
        contact: {
          ...state.contact,
          shares: {
            ...state.contact.shares,
            items,
          },
        },
      };
    }
    case FETCHING_CONTACT_ASSET_ANALYTICS_FAILED: {
      const { share: shareID, asset: assetID, section: sectionID, analytics } = action.payload;
    
      // Create a new items array to avoid mutating state
      const items = state.contact.shares.items.map(share => {
        if (share.id === shareID) {
          // Create a new assets array for the share
          const assets = share.assets.map(asset => {
            if (asset.id === assetID) {
              return {
                ...asset,
                analytics: {
                  ...asset.analytics,
                  fetch: false,
                  loading: false,
                  item: null,
                },
                preview: {
                  loading: false,
                  item: null,
                  fetch: true,
                },
              };
            }
            return asset; // Return existing asset if no changes
          });
    
          // Create a new sections array
          const sections = (share.sections || []).map(section => {
            if (section.id === sectionID) {
              // Create a new assets array for the section
              const sectionAssets = section.assets.map(asset => {
                if (asset.id === assetID) {
                  return {
                    ...asset,
                    analytics: {
                      ...asset.analytics,
                      fetch: false,
                      loading: false,
                      error: action.payload.error,

                    },
                    preview: {
                      loading: false,
                      item: null,
                      fetch: true,
                    },
                  };
                }
                return asset; // Return existing asset if no changes
              });
    
              // Return a new section object with updated assets
              return {
                ...section,
                assets: sectionAssets,
              };
            }
            return section; // Return existing section if no changes
          });
    
          // Return a new share object with updated assets and sections
          return {
            ...share,
            assets,
            sections,
          };
        }
        return share; // Return existing share if no changes
      });
    
      // Return a new state object
      return {
        ...state,
        contact: {
          ...state.contact,
          shares: {
            ...state.contact.shares,
            items,
          },
        },
      };
    }
    

    case FETCHING_ASSET_PREVIEW:
      var assetID = action.payload.id;

      var items = state.contact.shares.items.map((share) => {
        var sections = share.sections || [];

        var updatedSections = sections.map((section) => {
          var sectionassets = section.assets || [];

          var assets = sectionassets.map((asset) => {
            if (asset.id == assetID) {
              return Object.assign({}, asset, {
                ...asset,
                preview: {
                  loading: true,
                  item: null,
                  fetch: false,
                },
              });
            }

            return asset;
          });
          return {
            ...section,
            assets: assets,
          };
        });

        var assets = share.assets || [];

        assets = assets.map((asset) => {
          if (asset.id == assetID) {
            return Object.assign({}, asset, {
              ...asset,
              preview: {
                loading: true,
                item: null,
                fetch: false,
              },
            });
          }

          return asset;
        });

        return Object.assign({}, share, {
          ...share,
          sections: updatedSections,
          assets: assets,
        });
      });

      return Object.assign({}, state, {
        ...state,
        contact: {
          ...state.contact,
          shares: {
            ...state.contact.shares,
            items: items,
          },
        },
      });

    case FETCHING_ASSET_PREVIEW_SUCCEDDED:
      var assetID = action.payload.id;

      var items = state.contact.shares.items.map((share) => {
        var sections = share.sections || [];

        var updatedSections = sections.map((section) => {
          var sectionassets = section.assets || [];

          var assets = sectionassets.map((asset) => {
            if (asset.id == assetID) {
              return Object.assign({}, asset, {
                ...asset,
                preview: {
                  loading: false,
                  item: action.payload.result,
                  fetch: false,
                },
              });
            }

            return asset;
          });
          return {
            ...section,
            assets: assets,
          };
        });

        var assets = share.assets || [];

        assets = assets.map((asset) => {
          if (asset.id == assetID) {
            return Object.assign({}, asset, {
              ...asset,
              preview: {
                loading: false,
                item: action.payload.result,
                fetch: false,
              },
            });
          }

          return asset;
        });

        return Object.assign({}, share, {
          ...share,
          sections: updatedSections,
          assets: assets,
        });
      });

      return Object.assign({}, state, {
        ...state,
        contact: {
          ...state.contact,
          shares: {
            ...state.contact.shares,
            items: items,
          },
        },
      });

    case FETCHING_ASSET_PREVIEW_FAILED:
      var assetID = action.payload.id;

      var items = state.contact.shares.items.map((share) => {
        var sections = share.sections || [];

        var updatedSections = sections.map((section) => {
          var sectionassets = section.assets || [];

          var assets = sectionassets.map((asset) => {
            if (asset.id == assetID) {
              return Object.assign({}, asset, {
                ...asset,
                preview: {
                  item: null,
                  error: action.payload.error,
                  fetch: true,
                },
              });
            }

            return asset;
          });
          return {
            ...section,
            assets: assets,
          };
        });

        var assets = share.assets || [];

        assets = assets.map((asset) => {
          if (asset.id == assetID) {
            return Object.assign({}, asset, {
              ...asset,
              preview: {
                loading: false,
                item: null,
                error: action.payload.error,
                fetch: true,
              },
            });
          }

          return asset;
        });

        return Object.assign({}, share, {
          ...share,
          sections: updatedSections,
          assets: assets,
        });
      });

      return Object.assign({}, state, {
        ...state,
        contact: {
          ...state.contact,
          shares: {
            ...state.contact.shares,
            items: items,
          },
        },
      });

    case CREATING_CONTACT_REQUEST:
      return Object.assign({}, state, {
        ...state,
        contact: {
          ...state.contact,
          creating: true,
        },
      });
    case CREATING_CONTACT_SUCCEDDED:{
         const id = action.payload.id;

        var items = [...state.items, action.payload];

        items = _.uniqBy(items, "id");
        items = items.sort((a, b) => {
          if (a.id && b.id) {
            var n1 = a.firstName || "";
            var n2 = b.firstName || "";
            return n1.localeCompare(n2);
          }
        });

        return Object.assign({}, state, {
          ...state,
          contact: {
            ...state.contact,
            id: id,
            creating: false,
          },
          items: items,
        });
    }
      
    case CREATING_CONTACT_FAILED:
      return Object.assign({}, state, {
        ...state,
        contact: {
          ...state.contact,
          creating: false,
          error: action.payload,
        },
      });

    case UPDATING_CONTACT_REQUEST:
      return Object.assign({}, state, {
        ...state,
        contact: {
          ...state.contact,
          updating: true,
        },
      });
    case UPDATING_CONTACT_SUCCEDDED:
      {
        const id = action.payload.id;

        return Object.assign({}, state, {
          ...state,
          contact: {
            ...state.contact,
            updating: false,
            id: id,
            item: {
              ...state.contact.item,
              ...action.payload,
            },
          },
          items: state.items.map((contact, index) => {
            if (contact.id != id) {
              return contact;
            }

            return {
              ...action.payload,
            };
          }),
        });
      }
    case UPDATING_CONTACT_FAILED:
      return Object.assign({}, state, {
        ...state,
        contact: {
          ...state.contact,
          updating: false,
          error: action.payload,
        },
      });

    case DELETING_CONTACT_REQUEST:
      return Object.assign({}, state, {
        ...state,
        contact: {
          ...state.contact,
          deleting: true,
        },
      });
    case DELETING_CONTACT_FAILED:
      return Object.assign({}, state, {
        ...state,
        contact: {
          ...state.contact,
          deleting: false,
        },
      });

    case UNSUBSCRIBING_CONTACT_REQUEST:
      return Object.assign({}, state, {
        ...state,
        subscription: {
          ...state.subscription,
          updating: true,
          subscribed: true,
        },
      });

    case UNSUBSCRIBING_CONTACT_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        subscription: {
          ...state.subscription,
          updating: false,
          subscribed: false,
        },
      });

    case UNSUBSCRIBING_CONTACT_FAILED:
      return Object.assign({}, state, {
        ...state,
        subscription: {
          ...state.subscription,
          updating: false,
          error: action.payload,
        },
      });

    case RESUBSCRIBING_CONTACT_REQUEST:
      return Object.assign({}, state, {
        ...state,
        subscription: {
          ...state.subscription,
          updating: true,
        },
      });

    case RESUBSCRIBING_CONTACT_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        subscription: {
          ...state.subscription,
          updating: false,
          subscribed: true,
        },
      });

    case RESUBSCRIBING_CONTACT_FAILED:
      return Object.assign({}, state, {
        ...state,
        subscription: {
          ...state.subscription,
          updating: false,
          error: action.payload,
        },
      });

    case FETCHING_INTEGRATION_CONTACTS:
      var { integration, query } = action.payload;

      var items = state.integrations.items;
      if (!query) {
        items = [];
      }

      return Object.assign({}, state, {
        ...state,
        integrations: {
          ...state.integrations,
          id: integration,
          query: query,
          searching: true,
          fetched: false,
          items: items,
        },
      });

    case FETCHING_INTEGRATION_CONTACTS_SUCCEEDED:
      {
        var { integration, query, result } = action.payload;
        const items = result.records;

        var currentIntegration = state.integrations.id;
        if (integration != currentIntegration) {
          return state;
        }

        var currentQuery = state.integrations.query;
        if (query != currentQuery) {
          return state;
        }

        return Object.assign({}, state, {
          ...state,
          integrations: {
            ...state.integrations,
            searching: false,
            fetched: true,
            items: items,
            currentPage: result.currentPage,
            totalPages: result.totalPages,
            totalRecordsCount: result.totalRecordsCount,
            recordsPerPage: result.recordsPerPage,
          },
        });
      }

    case FETCHING_INTEGRATION_CONTACTS_FAILED:
      var { integration, query, error } = action.payload;

      var currentIntegration = state.integrations.id;
      if (integration != currentIntegration) {
        return state;
      }

      var currentQuery = state.integrations.query;
      if (query != currentQuery) {
        return state;
      }

      return Object.assign({}, state, {
        ...state,
        integrations: {
          ...state.integrations,
          searching: false,
          fetched: true,
          items: [],
          error: error,
        },
      });

    case INVALIDATE_INTEGRATION_CONTACTS:
      return Object.assign({}, state, {
        ...state,
        integrations: {
          ...state.integrations,
          id: null,
          query: null,
          searching: false,
          fetched: false,
          currentPage: -1,
          totalPages: 0,
          totalRecordsCount: 0,
          recordsPerPage: 12,
          loadMore: true,
          items: [],
          invalidated: true,
        },
      });


    default:
      return state;
  }
}

export { rolodexReducer };
